import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-movable-panel-title',
  standalone: true,
  templateUrl: './movable-panel-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col pt-6 px-4 pb-4 min-h-[32px]',
  },
})
export class MovablePanelTitleComponent {}
